"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
exports.NFT721Tool__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var ethers_1 = require("ethers");
var _abi = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_contractAddress",
                type: "address"
            },
            {
                internalType: "address[]",
                name: "_address",
                type: "address[]"
            },
            {
                internalType: "uint256[]",
                name: "_tokenIds",
                type: "uint256[]"
            },
        ],
        name: "batchTransfer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
];
var _bytecode = "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";
var isSuperArgs = function (xs) { return xs.length > 1; };
var NFT721Tool__factory = /** @class */ (function (_super) {
    __extends(NFT721Tool__factory, _super);
    function NFT721Tool__factory() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _this = this;
        if (isSuperArgs(args)) {
            _this = _super.apply(this, args) || this;
        }
        else {
            _this = _super.call(this, _abi, _bytecode, args[0]) || this;
        }
        return _this;
    }
    NFT721Tool__factory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    NFT721Tool__factory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    NFT721Tool__factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    NFT721Tool__factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    NFT721Tool__factory.createInterface = function () {
        return new ethers_1.utils.Interface(_abi);
    };
    NFT721Tool__factory.connect = function (address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    };
    NFT721Tool__factory.bytecode = _bytecode;
    NFT721Tool__factory.abi = _abi;
    return NFT721Tool__factory;
}(ethers_1.ContractFactory));
exports.NFT721Tool__factory = NFT721Tool__factory;
